export default "__VITE_ASSET__n_S8GRSl__"